<!--
  画面名：-
  概要： 食材/レシピデータをデータテーブルで表示するコンポーネント
  備考： -
-->

<!-- HTML -->
<template>
  <div class="content">
    <v-layout listWrapper>
      <v-flex :class="{'xs5':isOperation,'xs3 offset-9':!isOperation}">
        <!-- 食材/レシピの表示を切り替えるセレクトボックス -->
        <v-select
          v-model="select"
          :items="types"
          item-value="id"
          item-text="text"
          hide-details
          single-line
          outline
        />
      </v-flex>
      <v-spacer />
      <!--  検索要素  -->
      <v-flex :class="{'xs5':isOperation,'xs3 offset-9':!isOperation}" style="margin-left: auto; margin-right: 0;">
        <v-text-field
          v-model="search"
          append-icon="search"
          label="このリストを検索..."
          single-line
          hide-details
        />
      </v-flex>
    </v-layout>
    <template v-if="!isDialog">
      <div>
        <!--  原材料・仕込み品料理グループ一覧  -->
        <v-data-table
          :headers="tableHeader"
          :items="getTableData"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <!-- 名称 -->
            <td class="noWrap">
              {{ props.item.food }}
            </td>
            <!-- カテゴリー -->
            <td class="noWrap">
              {{ props.item.categoryName }}
            </td>
            <!-- グループ -->
            <td class="noWrap">
              {{ props.item.groupName }}
            </td>

            <!-- アレルゲン -->
            <td>
              <a v-if="allergenLength(props.item.allergen)" class="link-text" @click="allergenDialog(props.item.allergen)">{{ props.item.isAllergen }}</a>
              <span v-else>{{ props.item.isAllergen }}</span>
            </td>
            <!-- 工程を表示 -->
            <td v-for="(process, index) in processes" :key="index">
              <span v-if="props.item[process.valueName]">●</span>
              <span v-else>-</span>
            </td>
            <!-- 編集 雛形一覧のみ表示-->
            <td class="noWrap">
              <a v-if="isAuth" @click="editDialog(props.item)" class="link-text">{{ $language.LabelEdit }}</a>
              <span v-else>-</span>
            </td>
            <!-- 削除 雛形一覧のみ表示-->
            <td class="noWrap">
              <a v-if="isAuth" class="link-text" @click="deleteDialog(
                { food: props.item.food, type: props.item.type, category: props.item.category,
                  group: props.item.group, allergen: props.item.allergen, process: props.item.process,
                  cookingMaterial: props.item.cookingMaterial, baseId: props.item.baseId, itemId: props.item.itemId
                  }
                )">
                {{ $language.LabelDelete }}
              </a>
              <span v-else>-</span>
            </td>
          </template>
        </v-data-table>
        <!-- レシピ一覧 -->
      </div>
    </template>

    <template v-if="isDialog">
      <div class="dialog-datalist">
        <!--  原材料・仕込み品料理グループ一覧  -->
        <v-data-table
          v-model="selected"
          :headers="header"
          :items="getTableData"
          class="elevation-1"
        >
          <template v-slot:items="props">
            <td>
              <!-- チェック済の食材 -->
              <v-checkbox
                input-value="true"
                hide-details
                disabled
                v-if="props.item.exists"
              />
              <!-- チェックされていない食材 -->
              <v-checkbox
                v-model="props.selected"
                primary
                hide-details
                v-else
              />
            </td>
            <!-- 名称 -->
            <td class="noWrap">
              {{ props.item.food }}
            </td>
            <!-- カテゴリー -->
            <td class="noWrap">
              {{ props.item.categoryName }}
            </td>
            <!-- グループ -->
            <td class="noWrap">
              {{ props.item.groupName }}
            </td>
            <!-- アレルゲン -->
            <td v-if="!isOperation">
              {{ props.item.isAllergen }}
            </td>

            <!-- 作業工程 -->
            <td v-for="(process, index) in processes" :key="index">
              <span v-if="props.item[process.valueName]">●</span>
              <span v-else>-</span>
            </td>

          </template>
        </v-data-table>
        <!-- レシピ一覧 -->
      </div>
    </template>

    <!-- レシピデータ入力から食材を登録する（ダイアログ表示時） -->
    <ConfirmDialog
      :msg="$language.MsgConfirmDelete"
      @submit="deleteFoodData"
      ref="confirmDialog"
    />
  </div>
</template>
<!-- /HTML -->

<script>
// 確認用モーダル
import ConfirmDialog from '@/components/parts/common/ConfirmDialog'
import foodDataListHeader from '@/config/common/foodDataListHeader'
import SystemAndManagement from '@/components/pages/common/SystemAndManagement'

export default {
  // コンポーネントを登録
  components: {
    // 確認用ダイアログ
    ConfirmDialog
  },
  // 親コンポーネントから値を受け取る
  props: {
    // ダイアログの判定（食材追加）
    isDialog: { type: Boolean, default: false },
    // 料理で使用されている食材
    cookingMaterial: { type: Array, default: function () { return [] } },
    // 計画策定からの判定
    isPlan: { type: Boolean, default: false },
    // 計画策定からの判定
    isOperation: { type: Boolean, default: false },
    // 権限の判定（店舗責任者）
    isAuth: { type: Boolean, default: true }
  },
  // 初期値設定
  data () {
    return {
      // チェックボックス
      selected: [],
      // 食材データ
      arrFoodData: [],
      // カテゴリリスト
      categoryLists: [],
      // ヘッダー
      // セレクトボックスで選択する種別の項目を格納
      types: [],
      // セレクトボックスの選択初期値
      select: 0,
      // 検索文字
      search: '',
      processes: {},
      header: foodDataListHeader.ModalHeader,
      tableHeader: foodDataListHeader.Header

      // 表のヘッダー
    }
  },
  // 画面表示時に実行する関数を設定
  created () {
    // 親コンポーネントのcheckSelectionを発火
    this.$emit('checkSelection', this.select)
    // 工程のjsonデータを取得する
    this.getProcess()
  },
  // Vue インスタンスを監視
  watch: {
    // セレクトボックスの監視
    select (value) {
      // 親コンポーネントに選択されている種別を送る
      this.$emit('checkSelection', value)
      // データを取得
      this.getFoodData(true)
    }
  },
  computed: {
    // テーブルデータ取得処理
    getTableData () {
      // リストデータを作成
      let returnData = this.filter(this.arrFoodData, this.search)
      // 返却
      return returnData
    }
  },
  // コンポーネントの処理を記載
  methods: {
    // DBから工程を取得
    getProcess () {
      let self = this
      function callbackGetProcess (response) {
        // データベースから取得した工程一覧を格納
        self.processes = response
        self.formatHeader(response)
        self.$forceUpdate()
        self.getCategoryJson()
      }
      let data = {}
      data.callback = callbackGetProcess
      this.$store.dispatch('processes/actionSelectProcesses', data)
    },
    formatHeader (process) {
      let array = {}

      if (this.isOperation && this.header[4].text === 'アレルゲン') {
        this.header.splice(4, 1)
      }
      if (this.header.length > 5 || this.tableHeader.length > 4) {
        return
      }
      for (let i = 0; i < process.length; i++) {
        array = {
          'text': process[i].name,
          'value': process[i].valueName
        }
        this.header.push(array)
        this.tableHeader.push(array)
      }
      this.tableHeader.push({
        'text': '',
        'value': 'edit',
        'sortable': false
      }, {
        'text': '',
        'value': 'delete',
        'sortable': false
      })
    },
    // フィルター処理
    filter (datas, search) {
      let excludeArray = ['id', 'amount', 'itemId', 'type', 'category', 'group', 'allergen', 'process', 'exists']
      for (let i = 0; i < this.processes.length; i++) {
        excludeArray.push(this.processes[i].valueName)
      }
      return SystemAndManagement.filterMain(datas, search, excludeArray)
    },
    sendCehcks () {
      this.$emit('submit', this.selected)
    },
    // カテゴリのjsonデータを取得する
    getCategoryJson () {
      let self = this
      // カテゴリー一覧を取得した後のコールバック処理
      function callbackGetCategoryJson (response) {
        // データベースから取得したカテゴリー一覧を格納
        self.categoryLists = response
        // 食材種別を取得する
        self.getTypeList()
        self.$forceUpdate()
        // 食材データを取得する
        self.getFoodData()
      }
      let data = {}
      data.isOperation = this.$props.isOperation
      data.callback = callbackGetCategoryJson
      this.$store.dispatch('foodCategory/actionSelectFoodCategory', data)
    },

    // 食材の種別リストを取得する
    getTypeList () {
      let self = this
      // 食材種別リスト取得のコールバック処理
      function callbackGetTypeList (response) {
        self.types = response
        self.$forceUpdate()
      }
      let data = {}
      data.callback = callbackGetTypeList
      data.isOperation = this.$props.isOperation
      this.$store.dispatch('types/actionSelectTypes', data)
    },

    // 削除するか確認するダイアログを表示
    deleteDialog (item) {
      this.$refs.confirmDialog.openDialog(item)
    },
    // データベースの食材データ削除
    deleteFoodData (item) {
      let self = this
      // 食材データ削除を行った後のコールバック処理
      function callbackDeleteFoodData (response) {
        // プログレスバーの非表示
        self.$store.dispatch('setIsLoading', false)
        if (response.status === 200) {
          self.getFoodData()
        }
      }
      let data = {}
      data.callback = callbackDeleteFoodData
      if (this.isPlan) {
        // 食材名
        data.food = item.food
        // 種別
        data.type = item.type
        // カテゴリー
        data.category = item.category
        // 食材グループコード
        data.group = item.group
        // アレルゲン
        data.allergen = item.allergen
        // 工程
        data.process = item.process.join()
        // 雛形ID
        data.baseId = item.baseId
        // 料理に含まれる食材
        data.cookingMaterial = Object.keys(item.cookingMaterial).length === 0 ? '' : JSON.stringify(item.cookingMaterial)
        // 非表示フラグ
        data.isdelete_template_food_group = 1
        data.item = {}
        data.item.itemId = item.itemId
        data.item.baseId = item.baseId
        this.$store.dispatch('managementFunction/actionDeleteFoodData', data)
      } else {
        data.id = item.itemId
        // データベース連携を行い食材をデータベースから削除する
        this.$store.dispatch('systemConfig/actionDeleteFoodData', data)
      }
    },
    // DBから食材データを取得
    getFoodData (isShow) {
      this.arrFoodData = []
      let self = this
      // 食材データを格納するコールバック処理
      function callbackGetFoodData (response) {
        setdbFoodData(response)
        self.$forceUpdate()
        // プログレスバーの非表示
        if (!self.$props.isDialog || isShow) {
          setTimeout(() => {
            self.$store.dispatch('setIsLoading', false)
          }, 500)
        }
        if (self.$props.isOperation) {
          self.$emit('callback')
        }
      }
      this.arrFoodData = []
      let data = {}
      data.type = this.select
      data.isShow = isShow
      data.isOperation = this.$props.isOperation
      data.callback = callbackGetFoodData
      if (this.isPlan) {
        // 選択されているタイプの食材データを管理DBと雛形DBから取得する
        this.$store.dispatch('managementFunction/actionSelectFoodData', data)
      } else {
        // 選択されているタイプの食材データを雛形DBから取得する
        this.$store.dispatch('systemConfig/actionSelectFoodData', data)
      }

      // DBから取得したデータをVue用に入れ直す
      function setdbFoodData (data) {
        let isReception = false
        let isRawMaterialStorage = false
        let isThaw = false
        let isSterilization = false
        let isHeatSterilization = false
        let isCooling = false
        let isReheating = false
        let isHighTemperatureStorage = false
        let isTemporaryStorage = false
        let isDishing = false
        let isOffer = false
        let arrProcess = []
        for (let i = 0; i < data.length; i++) {
          // 工程を初期化
          isReception = false
          isRawMaterialStorage = false
          isThaw = false
          isSterilization = false
          isHeatSterilization = false
          isCooling = false
          isReheating = false
          isHighTemperatureStorage = false
          isTemporaryStorage = false
          isDishing = false
          isOffer = false
          arrProcess = []
          // DBに格納されている工程を配列に変換
          if (data[i].process) {
            arrProcess = data[i].process.split(',').map(Number)
            // 工程の有無の判定を行う
            arrProcess.forEach(function (value) {
              switch (value) {
                case 0:
                  isReception = true
                  break
                case 1:
                  isRawMaterialStorage = true
                  break
                case 2:
                  isThaw = true
                  break
                case 3:
                  isSterilization = true
                  break
                case 4:
                  isHeatSterilization = true
                  break
                case 5:
                  isCooling = true
                  break
                case 6:
                  isReheating = true
                  break
                case 7:
                  isHighTemperatureStorage = true
                  break
                case 8:
                  isTemporaryStorage = true
                  break
                case 9:
                  isDishing = true
                  break
                case 10:
                  isOffer = true
                  break
                default:
                  break
              }
            })
          }
          let baseId = ''
          if (self.isPlan) {
            baseId = data[i].template_food_group_id ? data[i].template_food_group_id : -1
          } else {
            baseId = data[i].template_food_group_id ? data[i].template_food_group_id : 0
          }
          let isExists = false
          if (self.cookingMaterial.length > 0) {
            self.cookingMaterial.some(function (value) {
              // 計画策定の時、チェックされている雛形の食材
              if (self.isPlan && value.baseId === 0 && data[i].id === -1) {
                if (value.itemId === data[i].template_food_group_id) {
                  isExists = true
                  return true
                }
              }

              if (value.itemId === data[i].id && value.baseId === baseId) {
                isExists = true
                return true
              }
            })
          }
          let isAllergen = '-'
          if (self.allergenLength(data[i].allergen)) {
            isAllergen = self.$language.LabelExist
          }
          // 食材グループ名を格納する
          let groupName = setGroupName(data[i].food_group_code)
          let cookingMaterialJson = []
          // 料理に含まれる原材料にも食材グループを格納
          if (data[i].cooking_material) {
            cookingMaterialJson = JSON.parse(data[i].cooking_material)
            cookingMaterialJson.forEach(function (value) {
              value.groupName = setGroupName(value.group)
            })
          }
          // categoryIDからcategory名を取得
          let catName = self.categoryLists[data[i].type].filter(function (element) { return element.id === data[i].category })

          // 食材データを配列に格納
          self.arrFoodData.push({
            id: i,
            amount: '',
            itemId: data[i].id,
            food: data[i].food_name,
            type: data[i].type,
            category: data[i].category,
            categoryName: catName[0].text,
            group: data[i].food_group_code,
            isdelete_template_food_group: data[i].isdelete_template_food_group,
            groupName: groupName,
            allergen: data[i].allergen,
            isAllergen: isAllergen,
            process: arrProcess,
            Reception: isReception,
            RawMaterialStorage: isRawMaterialStorage,
            Thaw: isThaw,
            Sterilization: isSterilization,
            HeatSterilization: isHeatSterilization,
            Cooling: isCooling,
            Reheating: isReheating,
            HighTemperatureStorage: isHighTemperatureStorage,
            TemporaryStorage: isTemporaryStorage,
            Dishing: isDishing,
            Offer: isOffer,
            baseId: baseId,
            cookingMaterial: cookingMaterialJson,
            exists: isExists
          })
        }
      }
      // 食材グループを設定する
      function setGroupName (value) {
        if (value === 0) {
          return self.$language.LabelGroup0
        } else if (value === 1) {
          return self.$language.LabelGroup1
        } else if (value === 2 || value === 3) {
          return self.$language.LabelGroup2
        } else if (value === 4 || value === 5) {
          return self.$language.LabelGroup3
        } else {
          return self.$language.LabelGroupNone
        }
      }
    },
    // アレルゲンに一つ以上チェックが入っているか確認する
    allergenLength (value) {
      if (value === null || value === '') return false
      if (value.length > 0) {
        return true
      } else {
        return false
      }
    },
    // ダイアログ表示時の設定
    setDialogHeader () {
      this.header.unshift({ 'sortable': false, 'value': 'checkbox' })
      this.header.pop()
      this.header.pop()
    },
    // 食材/レシピ一覧表示のデータテーブルのヘッダーをリセットする
    resetHeader () {
      let baseHeader = []
      Array.prototype.push.apply(baseHeader, foodDataListHeader.Header)
      this.header = baseHeader
      this.select = 0
      baseHeader.unshift(foodDataListHeader.FoodHeader)
    },
    // 親コンポーネントのダイアログを発火
    allergenDialog (item) {
      this.$emit('allergenDialog', item)
    },
    // 親コンポーネントのダイアログを発火
    editDialog (item) {
      this.$emit('editDialog', item)
    }
  }
}
</script>

<!-- style読み込み -->
<style lang="scss" scoped>
  @import '@/assets/scss/common/dialog.scss';
</style>
